export namespace Common {
  export class Guid {
    constructor(public guid: string) {
      this._guid = guid;
    }

    private _guid: string;

    public ToString(): string {
      return this.guid;
    }

    // Static member
    static MakeNew(): Guid {
      var result: string;
      var i: string;
      var j: number;

      result = "";
      for (j = 0; j < 32; j++) {
        if (j == 8 || j == 12 || j == 16 || j == 20) result = result + "-";
        i = Math.floor(Math.random() * 16)
          .toString(16)
          .toUpperCase();
        result = result + i;
      }
      return new Guid(result);
    }
    static MakeNewStr(): Guid {
      var result: string;
      var i: string;
      var j: number;

      result = "";
      for (j = 0; j < 32; j++) {
        i = Math.floor(Math.random() * 16).toString(16);
        result = result + i;
      }
      return new Guid(result);
    }
  }
  export class createNo {
    static createNo(): string {
      const projectTime = new Date(); // 当前中国标准时间
      const Year = projectTime.getFullYear(); // 获取当前年份 支持IE和火狐浏览器.
      const Month = projectTime.getMonth() + 1; // 获取中国区月份
      const Day = projectTime.getDate(); // 获取几号
      const hour = projectTime.getHours();
      const minute = projectTime.getMinutes();
      const second = projectTime.getSeconds();

      var CurrentDate = Year.toString();
      if (Month >= 10) {
        // 判断月份和几号是否大于10或者小于10
        CurrentDate += Month.toString();
      } else {
        CurrentDate += "0" + Month;
      }
      if (Day >= 10) {
        CurrentDate += Day;
      } else {
        CurrentDate += "0" + Day;
      }
      if (hour >= 10) {
        CurrentDate += hour;
      } else {
        CurrentDate += "0" + hour;
      }
      if (minute >= 10) {
        CurrentDate += minute;
      } else {
        CurrentDate += "0" + minute;
      }
      if (second >= 0) {
        CurrentDate += second;
      } else {
        CurrentDate += "0" + second;
      }
      CurrentDate += Math.floor(Math.random() * 10000).toString();
      return CurrentDate;
    }
  }
}
